import { useEffect, useState } from "react";
import { ArrowLeft, Building2, MapPin, Users } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import ApplicationDialog from "../components/ApplicationDialog";
import JobActions from "../components/JobActions";
import JobInfoGrid from "../components/JobInfoGrid";
import ResponsibilitiesList from "../components/ResponsibilitiesList";
import { JobStructuredData } from "../components/StructuredData";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function JobDetailsViewPage() {
  const { jobId } = useParams();
  const [job, setJob] = useState(null);
  const [showApplication, setShowApplication] = useState(false);

  useEffect(() => {
    fetch(`${API}/jobs/${jobId}`)
      .then((response) => response.ok ? response.json() : null)
      .then(setJob)
      .catch(() => setJob(null));
  }, [jobId]);

  if (!job) {
    return (
      <main className="page-width details-loading" data-testid="job-details-loading">
        Loading opportunity…
      </main>
    );
  }

  return (
    <main className="job-view-page page-width" data-testid="job-details-page">
      <JobStructuredData job={job} />
      <Link to="/" className="back-link" data-testid="back-to-jobs-link">
        <ArrowLeft size={18} /> All opportunities
      </Link>
      <section className="job-hero-card">
        <div className="job-hero-copy">
          <span
            className={`scheme-badge scheme-${job.scheme.toLowerCase().replaceAll(" ", "-")}`}
            data-testid="job-detail-scheme"
          >
            {job.scheme} opportunity
          </span>
          <p className="job-company-line" data-testid="job-detail-company">
            <Building2 size={18} /> {job.company}
          </p>
          <h1 data-testid="job-detail-title">{job.title}</h1>
          <div className="job-location-row">
            <MapPin size={18} /> {job.location}<span>•</span>
            <Users size={18} /> {job.openings} openings
          </div>
          <JobInfoGrid job={job} />
        </div>
        <JobActions onApply={() => setShowApplication(true)} />
      </section>
      <section className="job-detail-layout">
        <div className="job-detail-main">
          <section className="job-detail-content-card" data-testid="job-description-section">
            <span className="detail-section-kicker">The opportunity</span>
            <h2>Job Description</h2>
            <p data-testid="job-detail-description">{job.description}</p>
          </section>
          <ResponsibilitiesList responsibilities={job.responsibilities} />
          {job.facilities?.length > 0 && (
            <section className="job-detail-content-card" data-testid="job-facilities">
              <span className="detail-section-kicker">What we provide</span>
              <h2>Facilities</h2>
              <div className="facility-list">
                {job.facilities.map((facility) => (
                  <span
                    key={facility}
                    data-testid={`job-facility-${facility.toLowerCase().replaceAll(" ", "-")}`}
                  >
                    {facility}
                  </span>
                ))}
              </div>
            </section>
          )}
        </div>
        <aside className="job-side-note">
          <span>Candidate profile</span>
          <p>
            Suitable for candidates with <strong>{job.education}</strong> background who are
            {" "}ready for
            {" "}{job.work_type.toLowerCase()} work in {job.location}.
          </p>
        </aside>
      </section>
      {showApplication && <ApplicationDialog job={job} onClose={() => setShowApplication(false)} />}
    </main>
  );
}